import {StateType} from '@/types'
import type {UserType} from '@/types/user'
import {Module} from 'vuex'

const state = {
  user: {} as UserType,
  isHuiDuUsers: false,
}
type UserStateType = typeof state

const user: Module<UserStateType, StateType> = {
  namespaced: true,
  ...state,
}

export {UserStateType, state}
export default user
